module.exports = {
  searchPlaceholder: 'Search...',
  findCategory: 'Find Category',
  addCategory: 'Add another category',
  optionalFindCategory: 'Choose a secondary category (optional)',
  categoryLabel: 'Category*',
};



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/translations/category_select/en.js